/**
 * Disable Zod v4's JIT fast-path in the browser (side-effect module).
 *
 * Zod v4 compiles object validators with `new Function` for speed, and
 * feature-detects whether that's permitted with a `new Function("")` probe the
 * moment any `z.object()` schema is *constructed* (`zod/v4/core/util.js` →
 * `allowsEval`). Our app pages serve a strict CSP without `unsafe-eval`
 * (website/nginx.conf), so the probe is refused and the browser logs a
 * "Content Security Policy … blocks the use of 'eval'" violation pointing at
 * `zod/v4/core/util.js:149`. The section-schema union is bundled client-side
 * (registry/sections.ts → 19 `zod/v4` section schemas), so the probe trips on
 * hydration of every page. Zod already catches the EvalError and uses the
 * interpreted parser, so validation still works — the only symptom is the
 * console violation.
 *
 * Setting `jitless` makes Zod skip the probe entirely. The JIT path is
 * unreachable under our CSP anyway, so this is zero behavior/perf change in the
 * browser — it just stops the (caught) eval from being attempted. Server-side
 * has no CSP and benefits from the JIT, hence the `window` guard.
 *
 * Import this for its side effect *first*, before any Zod schema module
 * evaluates — see `src/renderer/+onRenderClient.tsx`.
 */
import { z } from "zod/v4";

if (typeof window !== "undefined") {
  z.config({ jitless: true });
}
